export const generateOrganizationSchema = (language: 'en' | 'th') => {
  const isEnglish = language === 'en';
  
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Medical Sterilization Systems Co.,Ltd.",
    "description": isEnglish 
      ? "Manufacturer of chemical indicators for sterilization monitoring in hospitals, dental clinics, and healthcare facilities. Established May 2023 in Bangkok, Thailand."
      : "ผู้ผลิตตัวบ่งชี้ทางเคมีสำหรับเฝ้าระวังกระบวนการทำให้ปราศจากเชื้อในโรงพยาบาล คลินิกทันตกรรม และสถานพยาบาล ก่อตั้ง พ.ค. 2566 กรุงเทพฯ ประเทศไทย",
    "url": "https://mss.in.th",
    "logo": "/images/Logo.jpg",
    "foundingDate": "2023-05",
    "foundingLocation": {
      "@type": "Place",
      "name": "Bangkok, Thailand"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Bangkok",
      "addressCountry": "TH"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+66 (0)26302115-6 +66 (0)65986990-0",
      "contactType": "customer service",
      "email": "admin@mss.in.th, hassawat.k@mss.in.th"
    },
    "sameAs": [
      "https://www.linkedin.com/company/medgaugex",
      "https://www.facebook.com/medgaugex"
    ]
  };
};

export const generateProductSchema = (language: 'en' | 'th') => {
  const isEnglish = language === 'en';
  
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": isEnglish ? "Chemical Indicators for Sterilization" : "ตัวบ่งชี้ทางเคมีสำหรับการทำให้ปราศจากเชื้อ",
    "description": isEnglish 
      ? "Chemical indicators for monitoring sterilization processes in healthcare facilities"
      : "ตัวบ่งชี้ทางเคมีสำหรับเฝ้าระวังกระบวนการทำให้ปราศจากเชื้อในสถานพยาบาล",
    "brand": {
      "@type": "Brand",
      "name": "Medical Sterilization Systems Co.,Ltd."
    },
    "manufacturer": {
      "@type": "Organization",
      "name": "Medical Sterilization Systems Co.,Ltd."
    },
    "category": "Medical Device",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceCurrency": "THB"
    }
  };
};